import React from 'react';
import { ChatConfig } from '../types';
import { getBrandingColor } from '../utils/brandingUtils';

interface ChatInputFormProps {
  inputRef: React.RefObject<HTMLTextAreaElement>;
  message: string;
  setMessage: (value: string) => void;
  isComposing: boolean;
  setIsComposing: (value: boolean) => void;
  handleSubmit: (e: React.FormEvent) => void;
  isLoading: boolean;
  config: ChatConfig | null;
}

/**
 * Renders the message input form, including the text area and send button.
 */
export const ChatInputForm: React.FC<ChatInputFormProps> = ({
  inputRef,
  message,
  setMessage,
  isComposing,
  setIsComposing,
  handleSubmit,
  isLoading,
  config,
}) => {
  return (
    <form onSubmit={handleSubmit} className="flex items-end gap-2">
      <div className="flex-1 rounded-lg border border-gray-300 bg-white focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500 shadow-sm">
        <textarea
          ref={inputRef}
          className="w-full px-4 py-3 focus:outline-none resize-none rounded-lg text-base leading-relaxed tracking-wide"
          style={{ maxHeight: '150px' }}
          rows={1}
          placeholder="Type your message..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey && !isComposing) {
              e.preventDefault();
              handleSubmit(e);
            }
          }}
          onCompositionStart={() => setIsComposing(true)}
          onCompositionEnd={() => setIsComposing(false)}
        />
      </div>
      
      <button
        type="submit"
        className="px-5 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed font-medium text-base shadow-sm"
        style={{ backgroundColor: getBrandingColor(config, 'primary') }}
        disabled={isLoading || !message.trim() || isComposing}
      >
        Send
      </button>
    </form>
  );
}; 